module.exports = __webpack_public_path__ + "c742bff1b7537df2ba2f74d3cdebc701.png";